import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ClientDetails } from '../models/client-details';
import {UrlBuilderService} from "@feature/common";

@Injectable()
export class ClientDetailsHttpService {

  constructor(
    private http: HttpClient,
    private urlBuilder: UrlBuilderService)
  { }

  getAllClients(): Observable<ClientDetails[]> {
    const clientsUrl = this.urlBuilder.getUrl('clients');
    return this.http.get<ClientDetails[]>(clientsUrl);
  }

  getClientDetails(clientRef: number): Observable<ClientDetails> {
    const clientsUrl = this.urlBuilder.getUrl(`client/${clientRef}/details`);
    return this.http.get<ClientDetails>(clientsUrl);
  }
}
